import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Testimonials from './pages/Testimonials';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import Checkout from './pages/Checkout';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ContactFormSlideUp from './components/ContactFormSlideUp';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');

  const handleOpenForm = (service = '') => {
    setSelectedService(service);
    setIsFormOpen(true);
  };

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header onCtaClick={handleOpenForm} />
          <Routes>
            <Route path="/" element={<Home onCtaClick={handleOpenForm} />} />
            <Route path="/about" element={<About onCtaClick={handleOpenForm} />} />
            <Route path="/services" element={<Services onCtaClick={handleOpenForm} />} />
            <Route path="/services/:slug" element={<ServiceDetail onCtaClick={handleOpenForm} />} />
            <Route path="/testimonials" element={<Testimonials onCtaClick={handleOpenForm} />} />
            <Route path="/blog" element={<Blog onCtaClick={handleOpenForm} />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
          </Routes>
          <Footer onCtaClick={handleOpenForm} />
          <ContactFormSlideUp 
            isOpen={isFormOpen} 
            onClose={() => setIsFormOpen(false)} 
            defaultService={selectedService}
          />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
